import storage from 'redux-persist/es/storage';
import {persistCombineReducers} from 'redux-persist';

import auth from './auth';
import users from './users';
import sites from './sites';
import positions from './positions';

const storageConfig = {
    whitelist: 'auth',
    key: 'certification_storage',
    storage
};

export default persistCombineReducers(storageConfig, {auth, users, sites, positions});